import React, { useState } from "react";
import { ChevronRight, ChevronLeft, Users, Layers } from "lucide-react";

const RoleDropdown = ({
  roles,
  selectedRole,
  selectedAgent,
  onRoleSelect,
  disabled = false,
  onNavigate,
  setSelectedAgent,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <>
      {/* COLLAPSED MODE */}
      {!isSidebarOpen && (
        <div className="fixed top-0 left-0 h-full w-12 bg-white/70 backdrop-blur-md border-r border-gray-200 shadow-lg flex flex-col items-center pt-4 z-50">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="p-2 rounded-md hover:bg-gray-100 text-gray-600"
          >
            <ChevronRight size={22} />
          </button>
        </div>
      )}

      {/* FULL SIDEBAR */}
      {isSidebarOpen && (
        <div
          className="fixed top-0 left-0 h-full bg-white/80 backdrop-blur-xl border-r border-gray-200 shadow-xl z-50 transition-all"
          style={{ width: "285px" }}
        >
          {/* HEADER */}
          <div className="p-5 border-b border-gray-200 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="/CI-logo.png"
                alt="CI Logo"
                className="h-10 cursor-pointer hover:opacity-80 transition"
                onClick={() => onNavigate("home")}
              />
              <div className="flex flex-col">
                <span className="text-xs text-black-600 tracking-wide">
                  AI Recruitment Platform
                </span>
              </div>
            </div>

            <button
              onClick={() => setIsSidebarOpen(false)}
              className="p-2 rounded hover:bg-gray-100 text-gray-600"
            >
              <ChevronLeft size={24} />
            </button>
          </div>

          {/* AGENTS SECTION */}
          <div className="px-5 py-4 border-b border-gray-200">
            <h3 className="text-sm font-semibold text-gray-800 mb-3 tracking-wide">
              Agents
            </h3>

            <SidebarItem
              label={
                <span className="text-base font-medium text-gray-800">
                  Recruiter Agent
                </span>
              }
              icon={<Users size={18} />}
              active={selectedAgent === "Recruiter Agent"}
              onClick={() => {
                setSelectedAgent("Recruiter Agent");
                onNavigate("recruiter");
              }}
            />

            <SidebarItem
              label={
                <span className="text-base font-medium text-gray-800">
                  Inventory Agent
                </span>
              }
              icon={<Layers size={18} />}
              active={selectedAgent === "Inventory Agent"}
              onClick={() => {
                setSelectedAgent("Inventory Agent");
                onNavigate("creyente");
              }}
            />
          </div>

          {/* FOOTER */}
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-white/80 border-t border-gray-200">
            {selectedAgent && (
              <div className="mb-2">
                <p className="text-xs text-gray-500">Selected Agent</p>
                <p className="text-sm font-semibold text-orange-600">
                  {selectedAgent}
                </p>
              </div>
            )}

            {selectedRole && (
              <div>
                <p className="text-xs text-gray-500">Selected Role</p>
                <p className="text-sm font-semibold text-orange-600">
                  {selectedRole.slice(0, -1)}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default RoleDropdown;

/* ===========================
   Sub Components
=========================== */

const SidebarItem = ({ label, icon, active, onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg shadow-sm transition-all text-sm 
      ${
        active
          ? "bg-orange-600 text-white shadow-md"
          : "bg-white text-gray-800 hover:bg-gray-100"
      }`}
  >
    {icon}
    <span className="font-medium">{label}</span>
  </button>
);
